import { GET_CONTRACTORS_REQUEST, CREATE_CONTRACTOR_REQUEST } from "./reducer";

export const getContractors = () => ({
    type: GET_CONTRACTORS_REQUEST 
});


export const createContractor = (contractorName: string, contractorDescription: string, contractorFirstName: string, contractorLastName: string, contractorMobileNumber: string, contractorWorkPhone: string, contractorEmail: string) => ({
    type: CREATE_CONTRACTOR_REQUEST,
    payload: {
        contractorName,
        contractorDescription,
        contractorFirstName,
        contractorLastName,
        contractorMobileNumber,
        contractorWorkPhone,
        contractorEmail
    }
})